import { UserInfo } from 'src/hooks/use_auth';
import {
  LdtOrderDetailFieldsFragment,
  OrderBaseFieldsFragment,
  OrderingProviderFieldsFragment,
  SamdOrderDetailFieldsFragment,
} from 'src/types';
import { InvitationErrorDetails } from 'src/types/errors';

export interface RootLayoutLoaderData {
  user: UserInfo;
}

export enum MemberAction {
  INVITE_USERS = 'inviteUsers',
  ASSIGN_ROLE = 'assignRole',
  REMOVE_USER = 'removeUser',
  REVOKE_INVITE = 'revokeInvite',
}

export type MemberActionResult = {
  success: boolean;
  action: MemberAction;
  invitationErrors?: InvitationErrorDetails[];
  successfulInvitations?: string[];
};

export enum OrderAction {
  CREATE = 'create',
  UPDATE = 'update',
  SUBMIT = 'submit',
  RESUBMIT = 'resubmit',
  CANCEL = 'cancel',
  DELETE = 'delete',
  // TODO: Use the DISPLAY PATIENT REPORT action instead of DOWNLOAD_REPORT
  DOWNLOAD_REPORT = 'download_report',
  DOWNLOAD_CLINICAL_DECISION_SUPPORT = 'download_clinical_decision_support',
  DOWNLOAD_COMBINED_REPORT = 'download_combined_report',
  DOWNLOAD_SLIDE_IMAGE = 'download_slide_image',
  CREATE_ORDERING_PROVIDER = 'create_ordering_provider',
  UPDATE_ORDERING_PROVIDER = 'update_ordering_provider',
  DELETE_ORDERING_PROVIDER = 'delete_ordering_provider',
  UPDATE_PATHOLOGY_LAB = 'update_pathology_lab',
  UPDATE_ORDER_STATUS_QC_APPROVED = 'update_order_status_qc_approved',
  REVERT_TO_QC_PENDING = 'revert_to_qc_pending',
  IMAGE_QC_APPROVE = 'image_qc_approve',
  IMAGE_QC_REJECT = 'image_qc_reject',
  FAX_TEST_REPORT_TO_PATHOLOGY_LAB = 'fax_test_report_to_pathology_lab',
  REFAX_REPORT_TO_ORDERING_PROVIDER = 'refax_report_to_ordering_provider',
  DISPLAY_REQUISITION = 'display_requisition',
  DISPLAY_PATIENT_REPORT = 'display_patient_report',
  DISPLAY_DE_IDENTIFIED_REPORT = 'display_de_identified_report',
  SHARE_TEST_REPORT = 'share_test_report',
  REVISE_REPORT = 'revise_report',
  REFAX_PATHOLOGY_FILES = 'refax_pathology_files',
  REJECT_DRAFT_REPORT = 'reject_draft_report',
  UPDATE_BILLING_HOLD = 'update_billing_hold',
  /** LDT: save QC Pending order that has AI report and set revert status (Lab/AI Processing) */
  UPDATE_REJECTED_ORDER = 'update_rejected_order',
}

/** Order-shaped payloads returned from order actions. */
export type OrderActionOrder =
  | LdtOrderDetailFieldsFragment
  | SamdOrderDetailFieldsFragment
  | OrderBaseFieldsFragment;

export type OrderActionResult = {
  success: boolean;
  order?: OrderActionOrder;
  /** Order id for actions that don't return full order (e.g. REVISE_REPORT) */
  orderId?: string;
  orderingProvider?: OrderingProviderFieldsFragment;
  action: OrderAction;
  error?: string;
};

/** Input for the "should we redirect away from order edit?" guard. */
export interface EditOrderGuardInput {
  order: OrderBaseFieldsFragment;
  userId: string;
  /** Base path for redirect e.g. `/orgName` → redirect becomes `${redirectBasePath}/orders/${orderId}` */
  redirectBasePath: string;
  orderId: string;
}

/** If non-null, loader should notifyError and redirect to redirectPath. */
export type EditOrderGuardResult = {
  redirectPath: string;
  errorMessage: string;
} | null;

export type GetEditOrderRedirect = (
  input: EditOrderGuardInput,
) => EditOrderGuardResult;
